import { Component, HostListener } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { AuthApi } from 'src/app/shared/apis/auth.api';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { CSInputComponent } from 'src/app/shared/components/cs-input/cs-input.component';
import { VerifyAction } from 'src/app/shared/interfaces/auth.interface';
import { ToastService } from 'src/app/shared/service/toast.service';
import { ValidatorService } from 'src/app/shared/service/validator.service';
import { LoginService } from '../login.service';
@Component({
  standalone: true,
  selector: 'reset-password-email',
  templateUrl: './reset-password-email.component.html',
  styleUrls: ['./reset-password-email.component.scss'],
  imports: [CSButtonComponent, CSIconButtonComponent, CSInputComponent, FormsModule, ReactiveFormsModule],
})
export class ResetPasswordEmailComponent {
  constructor(
    public dialogRef: MatDialogRef<ResetPasswordEmailComponent>,
    private authApi: AuthApi,
    private toast: ToastService,
    public loginService: LoginService,
  ) {}

  public form: FormGroup = new FormGroup({
    email: new FormControl('', { validators: [ValidatorService.emailValidator(), Validators.required] }),
  });

  public loading: boolean = false;

  get loginEmailHasError() {
    return !!this.form.controls['email'].errors && this.form.controls['email'].touched;
  }

  get loginEmailErrorText() {
    if (this.form.controls['email'].hasError('required')) return 'Required';
    if (this.form.controls['email'].hasError('email')) return 'Invalid email';
    return '';
  }

  @HostListener('document:keydown.enter', ['$event'])
  public onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !this.loginEmailHasError && !this.loading) {
      this.submit();
    }
  }

  async submit() {
    if (this.loading) return;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;
    try {
      const email = this.form.controls['email'].value;
      const verifyRes = await firstValueFrom(
        this.authApi.verifyEmailBeforeOtp({
          email,
          otpType: 'ResetPwd' as VerifyAction,
        }),
      );

      if (!verifyRes?.success) {
        this.toast.show({
          message: verifyRes?.message || 'This email is not registered.',
          type: 'fail',
        });
        return;
      }

      this.loginService.handleResetPasswordEmail(email);
    } catch (error) {
      console.error('reset password email verifyEmailBeforeOtp error', error);
    } finally {
      this.loading = false;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
